import _extends from "@babel/runtime-corejs3/helpers/extends";
import { getNowDate } from '../datepicker/helpers';
import { BasePicker } from '../datepicker/basepicker';
export var YEAR_FORMAT = 'YYYY-MM-DD ';
export var TIME_FORMAT = 'HH:mm:ss';
export var NOW_START = getNowDate();
export var NOW_END = getNowDate(true);
export var PREFIX = NOW_START.format(YEAR_FORMAT);
export var typeDefs = _extends({}, BasePicker.typeDefs, {
  value: [String, Array],
  min: String,
  max: String,
  step: String
});